import type { ShellUserAuthorityContextPermissions } from '../core/models'
import type { IdentityApi } from '../services/identity/models'

export const createShellIdentityApi = (identity: Partial<IdentityApi>): IdentityApi => {
  const identityPermissions = identity.permissions ?? []

  return {
    ...identity,
    permissions: identityPermissions ?? [],
    hasPermissions: (permissions: readonly ShellUserAuthorityContextPermissions[]) =>
      permissions.reduce<boolean>((result, permission) => {
        if (!identityPermissions.includes(permission)) {
          result = false
        }
        return result
      }, true),
  }
}
